import ActionTypes from "../actions/types";
import momentz from "moment-timezone";

let initialState = {
  showAdvancedBoard: false,
  // targetPrice: 0,
  // confidence: 8,
  showHideStrike: true,
  bidAskMid: "ask",
  hideShading: false,
  showModal: false,
  warningsRemoved: {},
  localTicker: "",
  isCopied: false,
  isDateSelected: false,
  selectedExpration: false,
  selectedDate: momentz
    .tz(new Date(), "America/New_York")
    .format("YYYY-MM-DD"),
  strikeValue: "all",
  nearValue: undefined,
  modalDate: momentz.tz(new Date(), "America/New_York").format("YYYY-MM-DD"),
  watchListModalIndex: [],
  favioute: false,
  zoom: "100%",
  watchListModal: false,
  snakOpen: false,
  snakMessage: "",
  check: [],
  checkPut: [],
  alertType: "success",
  holderModal: false,
  backFromAdvance: false,
  zoompercent: "100%",
  strikeWidth: "740px",
  leftSideWidth: "400px",
  transformScale: "1",
  callRows: [],
  putRows: [],
  warnings: [],
  noOMS: true
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_OPTION_CHAIN_STATE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/optionChainStateReducer.js